import React from 'react';

const SvgEye = (props) => (
  <svg width={13} height={8} {...props}>
    <path
      fill="#e25d34"
      d="M0 3.977C1.042 1.61 3.314 0 6.06 0c2.747 0 5.02 1.61 6.061 3.977-1.041 2.368-3.314 3.977-6.06 3.977-2.747 0-5.02-1.61-6.061-3.977zm6.06-2.462c-1.324 0-2.46 1.137-2.46 2.462 0 1.326 1.136 2.462 2.462 2.462 1.325 0 2.462-1.136 2.462-2.462 0-1.325-1.137-2.462-2.462-2.462z"
    />
  </svg>
);

export default SvgEye;
